import React, {Component, ReactNode} from 'react';
import './BaseCell.scss';
import {DisplayProperties} from '../../content/displayproperties/DisplayProperties';
import {CloseDirection} from '../../content/comparators/BaseComparator';
import {Box, Icon, TableCell} from '@mui/material';
import {ArrowDropDown, ArrowDropUp} from '@mui/icons-material';

interface BaseCellProperties {
    display: DisplayProperties;
    content: typeof Component;
}

export class BaseCell extends Component<BaseCellProperties> {
    override render(): ReactNode {
        let topShow = this.props.display.direction === CloseDirection.UP;
        let botShow = this.props.display.direction === CloseDirection.DOWN;

        const Content = this.props.content;
        return <TableCell align={'center'} sx={{paddingY: 0, paddingX: "1%", backgroundColor: this.props.display.background}}>
            <Box>
                <Icon style={{visibility: topShow ? 'visible' : 'hidden'}}>
                    <ArrowDropUp/>
                </Icon>
                <Box className={"content"}>
                    <Content {...this.props.display.detailedProperties}/>
                </Box>
                <Icon style={{visibility: botShow ? 'visible' : 'hidden'}}>
                    <ArrowDropDown/>
                </Icon>
            </Box>
        </TableCell>;
    }
}
